import { AlertTriangle, Info, ShieldAlert } from 'lucide-react'
import { type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Callout.module.scss'

export type CalloutVariant = 'warning' | 'danger' | 'neutral'

export interface CalloutProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  variant?: CalloutVariant
  title: ReactNode
  children?: ReactNode
  /** Ação opcional à direita (botão ou link). */
  action?: ReactNode
}

const ICONS: Record<CalloutVariant, ReactNode> = {
  warning: <AlertTriangle />,
  danger: <ShieldAlert />,
  neutral: <Info />,
}

/**
 * Aviso inline, sempre dentro do fluxo (nunca toast). ``role="status"`` por
 * padrão; passe ``role="alert"`` quando o aviso nasce de uma ação do usuário.
 */
export function Callout({ variant = 'warning', title, children, action, className, role, ...rest }: CalloutProps) {
  return (
    <div role={role ?? 'status'} className={cn(styles.callout, styles[`variant-${variant}`], className)} {...rest}>
      <span className={styles.icon} aria-hidden>
        {ICONS[variant]}
      </span>
      <div className={styles.text}>
        <p className={styles.title}>{title}</p>
        {children ? <div className={styles.body}>{children}</div> : null}
      </div>
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  )
}
